import { render, staticRenderFns } from "./PurchaseDetailCard.vue?vue&type=template&id=b4cdf394&"
import script from "./PurchaseDetailCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports